import {Component, Input} from "@angular/core";
import {AbstractControl} from "@angular/forms";

@Component({
    selector: 'app-input-error-message',
    template: `
      @if (isInitialized) {
        <div class="input-error">
          <ul>
            @if (control?.touched && control?.errors && control?.dirty) {
              <li>
                @if (hasErrors) {
                  <span>
                    {{ translation(error) | i18next }}
                  </span>
                }
              </li>
            }
          </ul>
        </div>
      }
      `,
    styleUrls: [],
    standalone: false
})

export class InputErrorMessageComponent {
  @Input() control: AbstractControl;
  @Input() name: string = "";

  constructor() {
  }

  get isInitialized() {
    return this.control && this.control instanceof AbstractControl;
  }

  get hasErrors() {
    if (this.control?.errors) {
      return Object.keys(this.control?.errors).length > 0;
    }

    return false;
  }

  get error() {
    if (this.control?.errors && Object.keys(this.control.errors)[0]) {
      return Object.keys(this.control.errors)[0];
    }

    return '';
  }

  translation(validation: string) {
    return !!this.name ? `${this.name}_error_${validation}` : `error_${validation}`;
  }
}